import { render, staticRenderFns } from "./BookCategoryList.vue?vue&type=template&id=82f8be90&"
import script from "./BookCategoryList.vue?vue&type=script&lang=js&"
export * from "./BookCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports